import {useContext, useEffect, useRef, useState} from "react";
import {useSetState} from "ahooks";
import {Button, Form, Input, message} from "antd";
import {isEmpty} from "lodash-es";
import {STitle} from "shj-components";
import {trimStr} from "@/utils/data.ts";
import {measureRoomAIPolish, measureRoomHouseInspection} from "@/services/crmTool.ts";

import {EditStepForm} from "@/pages/roomMeasurementTools/roomMeasurementManage/components/EditStepForm";
import {typeKeyEnum} from "@/pages/roomMeasurementTools/roomMeasurementManage/components/EditStepTable/typeEnum.ts";
import measureContext from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/AddOrEditSteps/measureContext.ts";

export const Step3 = (props) => {
  const {detailInfo, setLoading} = useContext(measureContext)
  const tableKeyArr: Record<string, any> = Object.values(typeKeyEnum)
  const tableRef = useRef()
  const [form] = Form.useForm()

  const [dataObj, setDataObj] = useSetState<any>({})
  const [AIPolishLoading, setAIPolishLoading] = useState(false)

  useEffect(() => {
    if (!isEmpty(detailInfo)) {
      form.setFieldsValue({
        suggestion: detailInfo.suggestion
      })
      const data = JSON.parse(detailInfo.houseInspectionData || null)
      const tableDataObj = {}
      if (!isEmpty(data)) {
        tableKeyArr.forEach(type => {
          if (type.dataKey) {
            data[type.dataKey] && (tableDataObj[type.key] = data[type.dataKey])
          } else {
            const tableData = {id: 1}
            type.formConfig.forEach(({name: key}) => {
              data[key] && (tableData[key] = data[key])
            })
            !isEmpty(tableData) && (tableDataObj[type.key] = [tableData])
          }
        })
        setDataObj(tableDataObj)
      }

    }
  }, [detailInfo]);

  const handleValues = (values) => {
    const submitData: Record<string, any> = {...values, measureRoomId: detailInfo.measureRoomId}
    const houseInspectionData = {}
    tableKeyArr.forEach(item => {
      const data = tableRef[item.key]?.getDataSource()
      console.log(data, item.dataKey)
      if (item.dataKey) {
        houseInspectionData[item.dataKey] = data
      } else {
        Object.keys(data?.[0] || {})?.forEach?.(key => {
          if (key !== 'id') {
            houseInspectionData[key] = data[0][key]
          }
        })
      }
    })
    console.log(houseInspectionData)
    submitData['houseInspectionData'] = JSON.stringify(houseInspectionData)
    return submitData
  }

  const onSubmit = () => {
    return new Promise((resolve, reject) => {
      form.validateFields().then(values => {
        setLoading(true)
        const submitData = handleValues(values)
        measureRoomHouseInspection(submitData).then(() => {
          resolve(submitData)
        }).finally(() => {
          setLoading(false)
        })
        console.log(submitData)
      }).catch(() => {
        message.error('详情与建议不能为空')
      })
    })
  }

  const onSaveCache = () => {
    const formValues = form.getFieldsValue()
    return Promise.resolve(handleValues(formValues))
  }

  const onAIPolish = () => {
    form.validateFields().then(values => {
      setAIPolishLoading(true)
      measureRoomAIPolish({measureRoomId: detailInfo.measureRoomId, content: values.suggestion}).then(res => {
        form.setFieldValue('suggestion', res)
      }).finally(() => setAIPolishLoading(false))
    })
  }

  if (props.stepRef) {
    props.stepRef.step3 = {onSubmit, onSaveCache}
  }

  return <div>
    {tableKeyArr.map(type => <EditStepForm data={dataObj[type.key]} key={type.key} tableRef={tableRef}
                                            type={type.key}/>)}
    <STitle title={'需求详诉与专业建议'} titleMode={'edit'}/>
    {/*<div className={styles.tempText}>*/}
    {/*  参考模板：*/}
    {/*  <p>- 房屋现状分析：如何利用优点，如何弥补缺点</p>*/}
    {/*  <p>- 常住人口需求+居住细节建议</p>*/}
    {/*  <p>- 空间布局/户改需求+专业建议</p>*/}
    {/*  <p>- 门窗/新风/暖通/净水/智能系统的适配建议</p>*/}
    {/*</div>*/}
    <Form layout={'vertical'} form={form} style={{marginTop: 10}}>
      <Form.Item name='suggestion'
                 label={<>详情与建议<Button loading={AIPolishLoading} disabled={AIPolishLoading} type={'link'}
                                            onClick={onAIPolish}>智能润色</Button></>}
                 required={true}
                 rules={[{required: true, message: '不能为空'}]}>
        <Input.TextArea placeholder={`参考模板：
- 房屋现状分析：如何利用优点，如何弥补缺点
- 常住人口需求+居住细节建议
- 空间布局/户改需求+专业建议
- 门窗/新风/暖通/净水/智能系统的适配建议`}
                        maxLength={500}
                        rows={5}
                        showCount/>
      </Form.Item>
    </Form>
  </div>
}